module.exports = __webpack_public_path__ + "static/media/watermark.3894446a.png";